import { userConstants } from "../actions/types";
const initialState = {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    token: "",
    isAuthenticated: false,
    profilePicture: "",
    verified: false,
};
export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case userConstants.SET_USER:
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isAuthenticated: true });
        case userConstants.LOGOUT:
            return Object.assign(Object.assign({}, state), { firstName: "", lastName: "", email: "", token: "", isAuthenticated: false, profilePicture: "", verified: false });
        default:
            return state;
    }
};
